<template>
  <div class="page-container">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.beanName" placeholder="任务名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      height="460"
      style="width: 100%;">
      <el-table-column
        prop="beanName"
        header-align="center"
        align="center"
        label="bean名称">
      </el-table-column>
      <el-table-column
        prop="methodName"
        header-align="center"
        align="center"
        label="方法名称">
      </el-table-column>
      <el-table-column
        prop="params"
        header-align="center"
        align="center"
        label="参数">
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        align="center"
        label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" size="small">成功</el-tag>
          <el-tag v-else @click.native="showErrorInfo(scope.row.error)" size="small" type="danger" style="cursor: pointer;">失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="times"
        header-align="center"
        align="center"
        label="耗时(单位: 毫秒)">
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        width="180"
        label="执行时间">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="page.pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="page.pageSize"
      :total="page.totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dataForm: {
          id: ''
        },
        dataList: [],
        page: {
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
        },
        dataListLoading: false
      }
    },
    created () {
      this.getDataList(this.page)
    },
    methods: {
      // 获取数据列表
      getDataList (page) {
        this.dataListLoading = true
        this.$axios.post("/uxm/scheduleLog/page", {
          beanName: this.dataForm.beanName,
          current: page == null ? this.page.pageIndex : page.pageIndex,
          size: page == null ? this.page.pageSize : page.pageSize,
        }).then(res => {
          this.dataList = res.data.data.records
          this.page.totalPage = res.data.data.total
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.page.pageSize = val
        this.getDataList(this.page)
      },
      // 当前页
      currentChangeHandle (val) {
        this.page.pageIndex = val
        this.getDataList(this.page)
      },
      // 失败信息
      showErrorInfo (error) {
        this.$alert(error)
      }
    }
  }
</script>
<style scoped>
  .page-container {
    padding: 16px;
  }
  .el-pagination {
    float: right;
    margin-top: 22px;
  }
</style>
